import React, { Component } from 'react'

export class jsloader extends Component {

    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default jsloader
